var _path, _path2, _path3, _ellipse, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReactmobileLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 66,
    viewBox: "0 0 127 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.151 21.5114C101.617 22.0832 100.056 22.6822 98.5222 23.254C94.7932 12.7437 85.2721 5.60982 74.4023 5.1197C63.5324 4.65681 53.4825 10.9467 48.9071 21.103C47.426 20.395 45.9185 19.6599 44.4375 18.9519C49.8592 6.94402 61.7869 -0.516653 74.6139 0.027922C87.4673 0.599726 98.7338 9.06787 103.151 21.5114Z",
    fill: "#30BCB0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0259 24.9421C92.439 25.5411 90.8786 26.1401 89.2918 26.7119C86.9116 20.0409 80.8816 15.4937 73.9788 15.1942C67.0761 14.8947 60.7023 18.8973 57.7931 25.3505C56.2856 24.6153 54.7516 23.8801 53.2441 23.1722C57.0261 14.8402 65.2777 9.63951 74.2168 10.0479C83.1296 10.4291 90.9315 16.3106 94.0259 24.9421Z",
    fill: "#30BCB0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8223 28.3999C83.2884 28.9717 81.7544 29.5435 80.2205 30.1426C77.946 23.771 69.3242 23.3898 66.5208 29.5435C65.0397 28.8356 63.5587 28.1276 62.0776 27.4197C66.7324 17.2089 81.0668 17.8079 84.8223 28.3999Z",
    fill: "#30BCB0"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.2652,
    cy: 32.7838,
    rx: 3.06789,
    ry: 3.15854,
    fill: "#30BCB0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5922 40.0121V46.7296H43.18V52.0718H32.5922V59.2389H43.4473V64.5811H26.6299V34.7757H43.4473V40.0121H32.5922Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1915 64.5811H15.7747C13.0476 59.9265 10.3204 55.2719 7.56651 50.6437L10.9354 50.5644C12.0316 50.5379 13.1812 50.2999 14.0636 49.6652C15.4004 48.7131 16.0956 46.8883 16.0688 45.1428C16.0421 43.9263 15.641 42.7626 14.8924 41.8634C14.0903 40.8849 12.8337 40.2502 11.577 40.0915C10.9888 40.0121 10.4006 40.065 9.81241 40.065H6.06925V64.6076H0V34.8021C3.95705 34.8021 7.94083 34.7757 11.8979 34.7757C13.4486 34.7757 14.732 35.0137 16.0688 35.5691C17.4057 36.1245 18.7692 36.9972 19.7585 38.1609C21.4697 40.1708 22.1113 43.08 21.7638 45.8304C21.4429 48.29 20.3734 50.6173 18.5019 52.0454C17.5661 52.7594 16.4699 53.2355 15.3202 53.5264C17.6196 57.2289 19.8922 60.905 22.1915 64.5811Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.4463 34.7757H63.3658L75.6915 64.5811H69.141L66.9753 58.6042H54.8368L52.6711 64.5811H46.1206L58.4463 34.7757ZM60.9058 41.9163L56.5745 53.8173H65.2372L60.9058 41.9163Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M127 34.7757V40.0386H120.637V64.5811H114.541V40.0386H108.177V34.7757H127Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M100.343 54.2933H106.572C104.22 61.5397 96.867 66.0092 89.247 64.8191C81.6538 63.629 76.0391 57.1496 76.0391 49.5329C76.0391 41.9163 81.6538 35.4368 89.247 34.2467C96.8403 33.0566 104.193 37.5261 106.572 44.7725H100.343C98.2841 40.7262 93.7388 38.4782 89.2203 39.6947C84.7553 40.8848 81.8944 45.0634 81.8944 49.5329C81.8944 54.0024 84.7553 58.1545 89.2203 59.3711C93.7388 60.5876 98.2573 58.3397 100.343 54.2933Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactmobileLogo);
export default __webpack_public_path__ + "static/media/Reactmobile_Logo.4595a858a09d51c2874d5bc2fd0d688c.svg";
export { ForwardRef as ReactComponent };